<template>
  <a-config-provider :locale="locale">
    <template #renderEmpty> </template>
    <div ref="table" class="table-comp">
      <a-table
        :style="{ width: width + 'px' }"
        :columns="columns"
        :data-source="data"
        :pagination="pagination ? pagination : page"
        :scroll="{
          x: xWidth
            ? xWidth
            : columnsWidth > tableWidth
            ? tableWidth
            : columnsWidth,
          y: height
        }"
        bordered
        :row-key="(record, index) => index"
        :row-class-name="customRow"
        @change="tableChange"
      >
        <template
          v-for="(item, index) in columns"
          :slot="item.dataIndex"
          slot-scope="text, record"
        >
          <div v-if="!item.scopedSlots" :key="index">
            <p
              :key="index"
              :style="item.style"
              class="p-text"
              :class="Number(text) ? 'text-effect' : ''"
            >
              {{ text }}
            </p>
          </div>
          <div v-else :key="index">
            <slot
              :name="item.scopedSlots && item.scopedSlots.customRender"
              v-bind="record"
            ></slot>
          </div>
        </template>
      </a-table>
    </div>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  // import zhHK from 'ant-design-vue/lib/locale-provider/zh_TW'

  // const localeVal =
  //   localStorage.getItem('locale') == 'zh'
  //     ? zhCN
  //     : localStorage.getItem('locale') == 'tw'
  //     ? zhHK
  //     : null

  export default {
    props: {
      width: {
        type: [Number, String],
        default: 'auto'
      },
      xWidth: {
        type: [Number, String],
        default: 0
      },
      yHeight: {
        type: [Number, String],
        default: 0
      },
      pagination: {
        type: [Object, Boolean],
        default: () => {}
      },
      columns: {
        type: Array,
        default: () => [],
        validator: data => {
          return data.map((item, index) => {
            item.key = index
            item.ellipsis = item.ellipsis !== undefined ? item.ellipsis : true
            item.align = item.align ? item.align : 'center'

            if (item.sorter === true) {
              item.sorter = (a, b) => {
                //不启用默认排序
                if (!item.closeDefaultSort) {
                  let aNum = a[item.dataIndex] + '' || ''
                  let bNum = b[item.dataIndex] + '' || ''
                  let numa = aNum.replace(/(\d+(\.\d+)?).*/g, '$1')
                  let numb = bNum.replace(/(\d+(\.\d+)?).*/g, '$1')
                  return numa - numb
                }
              }
            }
            return item
          })
        }
      },
      data: {
        type: Array,
        default: () => [],
        validator: data => {
          return data.map((item, index) => {
            item.key = index
            return item
          })
        }
      },
      customRow: {
        type: Function,
        default: () => ''
      }
    },
    data() {
      return {
        tableWidth: 0,
        page: {},
        columnsWidth: 0,
        height: 0,
        locale: zhCN
      }
    },
    watch: {
      pagination(value) {
        this.page = value
      },
      columns() {
        this.func()
      },
      data: {
        handler() {
          this.getTableBodyHeight()
        }
      }
    },
    mounted() {
      this.page = this.pagination

      window.onresize = () => {
        this.func()
      }
      setTimeout(() => {
        this.func()
        this.getTableBodyHeight()
      }, 100)
    },
    methods: {
      // 计算高度
      getTableBodyHeight() {
        if (this.data) {
          if (this.data.length > 13) {
            this.height = 600
          } else {
            this.height = 0
          }
        }
      },
      // 计算宽度
      func() {
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.columnsWidth = 0
            this.tableWidth = this.$refs.table.offsetWidth
            this.columns.forEach(item => {
              if (item.children) {
                item.children.forEach(ele => {
                  if (ele.width) {
                    this.columnsWidth += ele.width
                  } else {
                    this.columnsWidth += 100
                  }
                })
              } else {
                if (item.width) {
                  this.columnsWidth += item.width
                } else {
                  this.columnsWidth += 100
                }
              }
            })
            // console.log(this.columnsWidth, this.tableWidth, this.columns)
            if (this.columnsWidth <= this.tableWidth) {
              this.columns.forEach(item => {
                delete item.fixed
              })
            }
          }
        })
      },
      tableChange(pagination, filters, sorter) {
        this.page = pagination
        this.$emit('change', pagination, filters, sorter)
      }
    }
  }
</script>

<style lang="less" scope>
  .table-comp {
    .p-text {
      white-space: normal;
    }
    .ant-pagination-item-active {
      border-color: #1677ff;
      background: #1677ff;
      a {
        color: #ffffff;
      }
    }
    .ant-table-body {
      overflow-x: auto !important;
      border-bottom: 1px solid #e8e8e8;
    }
    .ant-table-hide-scrollbar {
      overflow: hidden !important;
      margin-bottom: -1px !important;
    }
    .ant-table-scroll .ant-table-hide-scrollbar {
      padding-right: 6px;
    }
    .ant-table-pagination {
      width: 100%;
      text-align: center;
      margin: 30px 0 0 0;
    }
  }
  .table-comp table p {
    margin: 0;
  }

  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(
      .ant-table-row-selected
    )
    > td,
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #e2ecff !important;
    cursor: pointer;
  }
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(
      .ant-table-row-selected
    )
    > td[rowspan],
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td[rowspan] {
    background: none !important;
  }
  .ant-table-thead > tr > th,
  .ant-table-thead > tr > th > .ant-table-column-sorters::before {
    background: #f4f4f4 !important;
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
  .ant-table-thead > tr > th {
    .ant-table-column-sorter-inner {
      .on {
        color: #fff !important;
      }
    }
  }

  .ant-table-tbody > tr:nth-child(even) td {
    background: #f9f9f9;
  }
  .ant-table-tbody > tr:nth-child(even) td[rowspan] {
    background: none;
  }
  .ant-table-tbody > tr > td {
    color: #1d1f24;
    font-size: 14px;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 12px 8px;
    text-align: center;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // user-select: none;
    position: relative;
    .score {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }
    .minScore {
      background: #ff8484;
    }
    .maxScore {
      background: #69d4aa;
    }
    .score1 {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .minScore1 {
      background: #fed4ca;
    }
    .maxScore1 {
      background: #e6f6f5;
    }
  }
</style>
